var exports = {
  "ag": "xaf9ae18d--5914a0--balloon",
  "Kk": "xaf9ae18d--5914a0--icon",
  "DD": "xaf9ae18d--5914a0--title",
  "Qs": "xaf9ae18d--5914a0--content",
  "lB": "xaf9ae18d--5914a0--min-price",
  "Kr": "xaf9ae18d--5914a0--roominess",
};

module.exports = exports;
